import React from 'react'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {OpState} from '../../core/_models'

interface StateCellProps {
  state: OpState
}

export const StateCell : React.FC<StateCellProps> = ({state}) => {
  const intl = useIntl()
  const value = state.state
  return (
    <div className='d-flex flex-column align-items-baseline'>
      <div className={clsx('badge', {
        'badge-light': ['INIT', 'UPDATED'].includes(value),
        'badge-primary': value === 'VALIDATED',
        'badge-danger': value === 'REJECTED',
        'badge-warning': value === 'PAID',
        'badge-success': value === 'PROCESSED',
        'badge-info': value === 'SPLITTED',
      })}>
        {value}
      </div>
      <span>
        {intl.formatDate(state.date, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        })}
      </span>
    </div>
  )
}

interface TypeCellProps {
  type: string
}

export const TypeCell: React.FC<TypeCellProps> = ({type}) => {
  const intl = useIntl()
  return (
    <div className={clsx('badge', {
      'badge-light-primary': type === 'BULK_ORDER',
      'badge-light-success': type === 'DEPOSIT',
      'badge-light-danger': type === 'API_ORDER',
      'badge-light-warning': type === 'BULK_ORDER_PART'
    })}>
      {intl.formatMessage({id: `P2C.SUPPLIER.OPERATION_${type}`})}
    </div>
  )
}

interface RefCellProps {
  reference: string;
  poNumber?: string;
}

export const RefCell: React.FC<RefCellProps> = ({reference, poNumber }) => {
  return (
    <div className='d-flex flex-column align-items-baseline'>
      <span className='mb-1'>
        {reference}
      </span>
      {poNumber && (
        <i className='d-flex text-info'>{poNumber}</i>
      )}
    </div>

  )
}
